import React from 'react';
import styles from './Wrapper.module.scss';

const Wrapper = ({children}) => {
    return (
        <main className={styles.wrapper}>
            {children}
        </main>
    );
};

export default Wrapper;
